import type { TaxCodeResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodTaxCodeResponseSchema } from './validations';

/**
 * Fetches one tax code by id.
 *
 * @param taxCodeId - The tax code id.
 * @param options - Additional request options.
 * @returns The requested tax code.
 * @see https://app.dev.vestigas.com/redoc#tag/Tax-Codes
 */
export const fetchTaxCode = async (
  taxCodeId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.TAX_CODE.GET(taxCodeId), {
      ...options,
      validate: {
        ...options?.validate,
        response: zodTaxCodeResponseSchema,
      },
    })
    .json<TaxCodeResponse>();
